import { Box, makeStyles } from "@material-ui/core";
import { formatNumber } from "App/utils/helpers";
import React from "react";

const useStyles = makeStyles({
  textRed: {
    color: "red",
  },
  border: {
    paddingTop: "10px",
    borderBottom: "1.5px dashed #333333",
  },
});

export default function ListTotalTagihan(data) {
  const classes = useStyles();
  return (
    <Box
      component="div"
      sx={{ padding: "20px 10px", background: "#ffffff", borderRadius: 10 }}>
      <div>
        <table width="100%" className="table-perhitungan-tagihan-wms">
          <tbody>
            <tr>
              <td width="40%">Total</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.total)}
              </td>
            </tr>
            <tr>
              <td width="40%">Pembayaran</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.pembayaran)}
              </td>
            </tr>

            <tr>
              <td colSpan="2"></td>
              <td colSpan="2" className={classes.border}></td>
            </tr>

            <tr>
              <td width="40%">Sisa</td>
              <td width="5%">:</td>
              <td width="55%" align="right">
                {formatNumber(data.data.sisa)}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </Box>
  );
}
